import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit {
  leftBannerImgurl = 'assets/images/forgot-password-banner.png';
  IsValidated = false;
  HasWhatsapp = false;
  EmailMode = false;
  HasEmail = false;
  GroupId;
  PasswordHash = '';
  WhatsAppMode = false;
  UserEmail: string = '';
  WhatsAppNo: string = '';
  ForgotPassword!: FormGroup;
  returnUrl!: string;
  PhoneNumber: any;
  UserName: any;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService,
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private authService: AuthenticationService
  ) { }

  ngOnInit(): void {
    this.ForgotPassword = this.formBuilder.group({
      username: ['', [Validators.required]],
      type: ['', [Validators.required]],
    });
    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';
  }

  // onSubmit(): void {

  //   // stop here if form is invalid
  //   if (this.ForgotPassword.invalid) {
  //     return;
  //   }
  //   if (this.ForgotPassword.value.type == "" || this.ForgotPassword.value.type == 1) {
  //     const key = {
  //       email: this.UserEmail,
  //       passwordHash: this.PasswordHash,
  //       username: this.ForgotPassword.value.username,
  //       url: document.location.origin
  //     }
  //     this.authService.ForgotPasswordEmail(key).subscribe((res: any) => {
  //       if (res) {
  //         this.toaster.success('Your password is sent to your email address.');
  //         this.router.navigate(['/login']);
  //       }
  //       else {
  //         this.toaster.error('Error', "Something wend wrong.");
  //       }
  //     },
  //       (error) => {
  //         this.toaster.error('Error', error.error.message);
  //       }
  //     );

  //   }
  //   else {
  //     const key = {
  //       WhatsAppNo: this.WhatsAppNo,
  //       passwordHash: this.PasswordHash,
  //       groupId: this.GroupId
  //     }
  //     this.authService.ForgotPasswordWhatsApp(key).subscribe((res: any) => {

  //       this.toaster.success('Your password is sent to your WhatsApp.');
  //       this.router.navigate(['/login']);
  //     },
  //       (error) => {
  //         this.toaster.error('Error', error.error.message);
  //       }
  //     );
  //   }
  // }

  // ValidateUserName(): any {
  //   const key = {
  //     username: this.ForgotPassword.value.username
  //   };
  //   this.authService.ValidateUserName(key).subscribe((res: any) => {

  //     if (res[0].Email) {
  //       this.IsValidated = true
  //       this.PasswordHash = res[0].Password;
  //       this.UserEmail = res[0].Email;
  //       this.EmailMode = true;
  //       this.GroupId = res[0].groupId;
  //       this.WhatsAppMode = false;
  //       this.ForgotPassword.get("type").setValue(1);
  //       if (res[0].Mobile) {
  //         this.HasWhatsapp = true;
  //         this.WhatsAppNo = res[0].Mobile;
  //       }
  //       else {
  //         this.HasWhatsapp = false;
  //       }
  //     }
  //     else {
  //       this.IsValidated = false;
  //       this.toaster.error('Error', 'User Not Found');
  //       this.EmailMode = false;
  //       this.WhatsAppMode = false;
  //       this.ForgotPassword.get("type").setValue(null);
  //     }
  //   },
  //     (error) => {
  //       this.toaster.error('Error', error.error.message);
  //     }
  //   );

  // }

  changeMode(event: any): void {
    if (event.value == 1) {
      this.HasEmail = true;
      this.EmailMode = true;
      this.WhatsAppMode = false;
    }
    else if (event.value == 2) {
      // this.HasEmail = false;
      this.EmailMode = false;
      this.WhatsAppMode = true;
    }
  }

  checkUserExistence(): void {
    const key = {
      UserNameOrEmail: this.ForgotPassword.value.username
    };
    this.spinner.show();
    this.commonService.checkUserExistence(key).pipe(finalize(() => this.spinner.hide())).subscribe((res: any) => {
     if (res.message.includes("User Found!")) {
        if (res.email || res.phoneNumber) {
          this.IsValidated = true
          this.UserEmail = res.email;
          this.UserName = res.userName;
          this.EmailMode = true;
          this.HasEmail = true;
          this.WhatsAppMode = false;
          this.HasWhatsapp = false;
          this.ForgotPassword.get("type").setValue(1);
          this.toaster.success('Success', res.message);
          if (res.phoneNumber) {
            this.WhatsAppNo = res.phoneNumber;
            this.GroupId = res.groupCode;
            this.HasWhatsapp = true;
            // this.WhatsAppMode = true;
          }
          else {
            this.HasWhatsapp = false;
          }
        }
        else if (res.phoneNumber) {
          this.IsValidated = true
          this.EmailMode = false;
          this.HasEmail = false;
          this.WhatsAppNo = res.phoneNumber;
          this.GroupId = res.groupCode;
          this.HasWhatsapp = true;
          this.WhatsAppMode = true;
          this.ForgotPassword.get("type").setValue(2);
        }
        else {
          this.IsValidated = false;
          this.HasEmail = false;
          this.EmailMode = false;
          this.WhatsAppMode = false;
        }
      }
      else {
        this.IsValidated = false;
        this.toaster.error(res.message);
        this.EmailMode = false;
        this.HasEmail = false;
        this.WhatsAppMode = false;
        this.ForgotPassword.get("type").setValue(null);
      }
    },
      (error) => {
        if (error.error.message === "Couldn't Find User!") {
          this.IsValidated = false;
          this.EmailMode = false;
          this.WhatsAppMode = false;
          this.ForgotPassword.get("type").setValue(null);
          this.toaster.error(error.error.message);
          return;
        }
        else
        this.toaster.error('Error', error.error.message);
        console.log(error);
      }
    );
  }

  onSubmit(): void {
    if (this.ForgotPassword.invalid) {
      return;
    }
    if (this.ForgotPassword.value.type == "" || this.ForgotPassword.value.type == 1) {
      const key = {
        email: this.UserEmail,
      }
      this.commonService.sendForgotPasswordEmail(key).subscribe((res: any) => {
        this.toaster.success('Your password reset link is sent to your email address.');
        this.router.navigate(['/login']);
      },
        ({ error }) => {
          this.toaster.error('Error', error.message);
        }
      );
    }

    else {
      const key = {
        username: this.UserName
      }
      this.commonService.sendForgotPasswordWhatsapp(key).subscribe((res: any) => {
        const newpassword = res.message;
        this.toaster.success('Your password reset link is sent to your whatsApp number.');
        this.router.navigate(['/login']);
        // this.ForgetpasswordWhatsapp(newpassword)

      },
        (error) => {
          this.toaster.error('Error', error.message);
        }
      );
    }

  }

  ForgetpasswordWhatsapp(data: any): void {

    const key = {
      WhatsAppNo: this.WhatsAppNo,
      passwordHash:
        data,
      groupId: this.GroupId
    }
    this.authService.ForgotPasswordWhatsApp(key).subscribe((res: any) => {
      console.log(res);
      this.toaster.success('Your password reset link is sent to your whatsApp number.');
      this.router.navigate(['/login']);
    },
      ({ error }) => {
        this.toaster.error('Error', error.message);
      }
    );
  }

}
